import React, { useState, useRef, useEffect } from "react";
import Settings from "./Settings";
import "./Header.css";

const Header = ({ user, onLogout, onLoginClick, onSignupClick, onDashboardEdit }) => {
  const [showMenu, setShowMenu] = useState(false);
  const [showSettings, setShowSettings] = useState(false);
  const menuRef = useRef(null);

  const today = new Date().toLocaleDateString("en-US", {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setShowMenu(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <>
      <header className="header">
        <div className="header-left">
          <h1 className="title">PomTask</h1>
          <p className="subtitle">Organiza tus tareas y eventos</p>
        </div>

        <div className="header-center">
          <h1>Dashboard</h1>
        </div>

        <div className="header-right">
          <span className="date">{today}</span>
          {user ? (
            <div className="user-menu-container" ref={menuRef}>
              <button
                className="user-icon-btn"
                onClick={() => setShowMenu(!showMenu)}
                aria-label="Menu de usuario"
              >
                👤
              </button>
              {showMenu && (
                <div className="menu-popup">
                  <div className="menu-email">{user.email}</div>
                  <button
                    className="menu-item"
                    onClick={() => {
                      setShowSettings(true);
                      setShowMenu(false);
                    }}
                  >
                    Ajustes
                  </button>
                  <button
                    className="menu-item"
                    onClick={() => {
                      onDashboardEdit();
                      setShowMenu(false);
                    }}
                  >
                    Personalizar Dashboard
                  </button>
                  <button className="menu-item logout" onClick={onLogout}>
                    Cerrar sesión
                  </button>
                </div>
              )}
            </div>
          ) : (
            <>
              <button className="login-btn" onClick={onLoginClick}>
                Login
              </button>
              <button className="register-btn" onClick={onSignupClick}>
                Register
              </button>
            </>
          )}
        </div>
      </header>
      <Settings
        isOpen={showSettings}
        onClose={() => setShowSettings(false)}
      />
    </>
  );
};

export default Header;
